/**
 * 系统设置模块action
 */
import oData from '../server/odata_client';
import rData from '../server/rest_client';
import * as ofbiz from '../server/ofbiz';
import Utils from '../script/utils.js';
import { logout } from './login_action';
import { createOperationAudit, updateOperationAudit } from './operationAudit_action';
import { getTreeNodeAssociation } from './deviceMonitor_action';

export const SET_SETTINGVIEWTYPE = 'SET_SETTINGVIEWTYPE';
export const SET_SUBMENUSETTINGVIEWTYPE = 'SET_SUBMENUSETTINGVIEWTYPE';
export const SET_USERINFO = 'SET_USERINFO';
export const SET_USERLIST = 'SET_USERLIST';
export const SET_ORGANIZATIONDATA = 'SET_ORGANIZATIONDATA';
export const SET_ORGANIZATIONROLEDATA = 'SET_ORGANIZATIONROLEDATA';
export const SET_AREADATA = 'SET_AREADATA';
export const SET_UNITDATA = 'SET_UNITDATA';
export const SET_DEPARTMENTDATA = 'SET_DEPARTMENTDATA';
export const SET_DEPARTMENTJOBDATA = 'SET_DEPARTMENTJOBDATA';
export const SET_ROLELIST = 'SET_ROLELIST';
export const SET_PERMISSIONDATA = 'SET_PERMISSIONDATA';
export const SET_ROLEPERMISSION = 'SET_ROLEPERMISSION';
export const SET_GROUPLIST = 'SET_GROUPLIST';
export const SET_ECCGROUPDATA = 'SET_ECCGROUPDATA';
export const SET_DBCONNECTIONLIST = 'SET_DBCONNECTIONLIST';
export const SET_DBCONNECTIONINFO = 'SET_DBCONNECTIONINFO';
export const SET_BACKGROUNDINFO = 'SET_BACKGROUNDINFO';
export const SET_BACKGROUNDSERVICES = 'SET_BACKGROUNDSERVICES';
export const SET_SELFCHECKDATA = 'SET_SELFCHECKDATA';
export const SET_LICENSE_DATA = 'SET_LICENSE_DATA';
export const SET_IMAGERESOURCE_DATA = 'SET_IMAGERESOURCE_DATA';
export const SET_DBDEFAULTBACKDBURL = 'SET_DBDEFAULTBACKDBURL';
export const SET_SCHEDULER_DATA = 'SET_SCHEDULER_DATA';
export const SET_SELFCHECKDATA_STATUSNUM = 'SET_SELFCHECKDATA_STATUSNUM';

export function setSettingViewType(settingViewType){
    return {
        type: SET_SETTINGVIEWTYPE,
        settingViewType
    }
}

export function setSubmenuSettingViewType(submenuSettingViewType){
    return {
        type: SET_SUBMENUSETTINGVIEWTYPE,
        submenuSettingViewType
    }
}

export function setUserInfo(userInfo){
    return {
        type: SET_USERINFO,
        userInfo
    }
}

export function setUserList(userList){
    return {
        type: SET_USERLIST,
        userList
    }
}

export function setOrganizationData(organizationData){
    return {
        type: SET_ORGANIZATIONDATA,
        organizationData
    }
}

export function setOrganizationRoleData(organizationRoleData){
    return {
        type: SET_ORGANIZATIONROLEDATA,
        organizationRoleData
    }
}

export function setAreaData(areaData){
    return {
        type: SET_AREADATA,
        areaData
    }
}

export function setUnitData(unitData){
    return {
        type: SET_UNITDATA,
        unitData
    }
}

export function setDepartmentData(departmentData){
    return {
        type: SET_DEPARTMENTDATA,
        departmentData
    }
}

export function setDepartmentJobData(departmentJobData){
    return {
        type: SET_DEPARTMENTJOBDATA,
        departmentJobData
    }
}

export function setRoleList(roleList){
    return {
        type: SET_ROLELIST,
        roleList
    }
}

export function setPermissionData(permissionData){
    return {
        type: SET_PERMISSIONDATA,
        permissionData
    }
}

export function setRolePermission(rolePermission){
    return {
        type: SET_ROLEPERMISSION,
        rolePermission
    }
}

export function setGroupList(groupList){
    return {
        type: SET_GROUPLIST,
        groupList
    }
}

export function setEccGroupData(eccGroupData){
    return {
        type: SET_ECCGROUPDATA,
        eccGroupData
    }
}

export function setDBConnectionList(DBConnectionList){
    return {
        type: SET_DBCONNECTIONLIST,
        DBConnectionList
    }
}

export function setDBConnectionInfo(DBConnectionInfo){
    return {
        type: SET_DBCONNECTIONINFO,
        DBConnectionInfo
    }
}

export function setBackgroundInfo(backgroundInfo){
    return {
        type: SET_BACKGROUNDINFO,
        backgroundInfo
    }
}

export function setBackgroundServices(backgroundServices){
    return {
        type: SET_BACKGROUNDSERVICES,
        backgroundServices
    }
}

export function setSelfCheckData(selfCheckData){
    return {
        type: SET_SELFCHECKDATA,
        selfCheckData
    }
}

export function setLicenseData(licenseData){
    return {
        type: SET_LICENSE_DATA,
        licenseData
    }
}

export function setImageResourceData(imageResourceData){
    return {
        type: SET_IMAGERESOURCE_DATA,
        imageResourceData
    }
}

export function setDBDefaultBackDbUrl(dbDefaultBackDbUrl){
    return {
        type: SET_DBDEFAULTBACKDBURL,
        dbDefaultBackDbUrl
    }
}

export function setSchedulerData(schedulerData){
    return {
        type: SET_SCHEDULER_DATA,
        schedulerData
    }
}

export function setSelfCheckDataStatusNum(selfCheckDataStatusNum){
    return {
        type: SET_SELFCHECKDATA_STATUSNUM,
        selfCheckDataStatusNum
    }
}

export function receiveCreateOperationAudit(param) {
    return dispatch => {
      dispatch(createOperationAudit(param));
    }
}

//获取当前用户信息
export function getUserInfo(callback){
  return dispatch => {
    rData.getUserInfo((data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setUserInfo(null));
        callback && callback();
      }
      else {
        dispatch(setUserInfo(data));
        callback && callback(data);
      }
    }, (status)=>{
      dispatch(setUserInfo(null));
      callback && callback();
      Utils.showMessageDialog("提示","获取用户管理详细信息失败。");
    });
  }
}

// ===========================================================================
// OFBiz 新接口适配辅助函数（用户 / 角色 / 组织 / 安全群组）
// 新接口返回 camelCase，旧页面消费 PascalCase，统一在此做字段映射，
// 保持 setting_action 各函数签名不变，页面无需大改。
// ===========================================================================

// 新接口用户 -> 旧前端 PascalCase 结构
function adaptUserToLegacy(u) {
  return {
    RecId: u.partyId,
    LoginID: u.userLoginId,
    DisplayName: u.nickname || [u.lastName, u.firstName].filter(Boolean).join('') || u.userLoginId || '',
    GroupName: u.orgName || '',
    Roles: (u.securityGroups || []).map(g => (g && (g.groupName || g.securityGroupId || g))),
    Email: u.email || '',
    Cellphone: u.mobile || '',
    Department: u.orgName || '',
    Status: u.enabled === 'N' || u.enabled === 'false' ? '已终止' : '活动',
  };
}

// 新接口角色 -> 旧结构（附 RoleId=groupId 供删除/分配权限使用）
function adaptRoleToLegacy(r) {
  return {
    RoleId: r.groupId,
    RoleName: r.groupName || r.groupId,
    RoleDescription: r.description || '',
  };
}

// 把用户表单提交的"角色名/团队名"解析为安全组 ID（新架构 assignGroups 需要 groupId）
// 入参可能是 ID（IT_ 开头）或名称（角色名/团队名），返回统一逗号分隔的 ID 串。
function resolveGroupIds(groupIds) {
  if (!groupIds) return Promise.resolve('');
  const names = String(groupIds).split(',').filter(Boolean);
  if (!names.length) return Promise.resolve('');
  return Promise.all([ofbiz.getRoleList({}, 1, 500), ofbiz.getSafeGroupList()]).then(([roleRes, teams]) => {
    const map = {};
    ((roleRes && roleRes.list) || []).forEach(r => {
      if (r.groupId) { map[r.groupId] = r.groupId; map[r.groupName || r.groupId] = r.groupId; }
    });
    (teams || []).forEach(t => {
      if (t.Id) { map[t.Id] = t.Id; map[t.Name] = t.Id; }
    });
    return names.map(n => map[n] || n).filter(Boolean).join(',');
  });
}

// 获取用户列表
export function getUserList(callback, checkTip){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /user/list ===
    // 旧返回 { users:[...] }，新返回 { list:[...] }。
    // 后端 list 元素已直接按旧 PascalCase 返回（RecId/LoginID/Roles/Email...），
    // 不再需要 adaptUserToLegacy 转换；仅对 camelCase 字段做兼容兜底。
    ofbiz.getUserList({}, 1, 500).then(res => {
      const list = ((res && res.list) || []).map(u => {
        if (u && u.LoginID != null) return u; // 后端已是旧结构
        return adaptUserToLegacy(u);
      });
      dispatch(setUserList(list));
      callback && callback(1);
    }).catch(() => {
      dispatch(setUserList([]));
      callback && callback(0);
    });
  }
}

//操作用户（增、删、改）
export function operateUser(params, callback, isPersonal){
  return dispatch => {
    let auditData = {
      type: 'add_user',
      BoId: 'user',
      desc: `${params.LoginId}`,
      OperationAssociation: '系统设置/用户角色管理/用户管理'
    }
    if (params.Operate == 'add' && !params.batch) {
      auditData.type = 'add_user';
    } else if (params.Operate == 'edit') {
      auditData.type = 'edit_user';
    } else if (params.Operate == 'delete' && !params.batch) {
      auditData.type = 'delete_user';
    } else {
      auditData = null;
    }
    if (isPersonal) {
      auditData.OperationDesc = `${params.LoginId}修改个人信息`;
      auditData.OperationAssociation = '';
    }
    if (params.hasOwnProperty('batch')) {
      delete params.batch;
    }
    // === 已切换到 OFBiz 新接口 ===
    // add -> /user/create，edit -> /user/update，delete -> /user/delete
    // 旧字段映射：LoginId->userLoginId, UserName/DisplayName->nickname,
    // Email/Cellphone -> user/updateContacts(随 update 提交), PassWd->password
    let promise = null;
    if (params.Operate == 'delete') {
      // 新接口按 partyId 删除；页面删除时传 partyId/RecId
      promise = ofbiz.deleteUser(params.partyId || params.RecId || params.LoginId);
    } else if (params.Operate == 'edit') {
      // 角色/安全组名称先解析为 groupId，再走 /user/update + /user/assignGroups（覆盖式）
      promise = resolveGroupIds(params.groupIds).then(groupIds => {
        return ofbiz.updateUser({
          partyId: params.partyId || params.RecId,
          nickname: params.UserName || params.DisplayName || '',
          firstName: params.FirstName || '',
          lastName: params.LastName || '',
          email: params.Email || '',
          mobile: params.Cellphone || '',
        }).then(data => {
          if (groupIds) {
            return ofbiz.assignGroups(params.LoginId, groupIds).then(() => data);
          }
          return data;
        });
      });
    } else { // add
      promise = resolveGroupIds(params.groupIds).then(groupIds => {
        return ofbiz.createUser({
          userLoginId: params.LoginId,
          password: params.PassWd || params.password || '',
          nickname: params.UserName || params.DisplayName || '',
          groupIds: groupIds,
          email: params.Email || '',
          mobile: params.Cellphone || '',
        });
      });
    }
    promise.then((data) => {
      if (params.Operate == 'edit') {
        Utils.showMessageDialog("提示","修改成功。");
        callback && callback();
      }
      else {
        callback && callback('success');
      }
      auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
    }).catch((err) => {
      auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      if (params.Operate == 'edit') {
        Utils.showMessageDialog("提示", (err && err.message) || "修改失败。");
        callback && callback();
      }
      else {
        callback && callback((err && err.message) ? err.message : 'error');
      }
    });
  }
}

//获取安全群组数据
export function getOrganizationData(callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /safeGroup/list ===
    // 用户表单"运维团队"下拉：旧取 OData Organization（o_name），
    // 新架构运维团队 = SecurityGroup（doc/04A），映射 {RecId: Id, o_name: Name}
    ofbiz.getSafeGroupList().then(groups => {
      const data = (groups || []).map(g => ({ RecId: g.Id, o_name: g.Name }));
      dispatch(setOrganizationData(data));
      callback && callback(data);
    }).catch(() => {
      dispatch(setOrganizationData([]));
      callback && callback([]);
    });
  }
}

//获取安全群组下的角色
export function getOrganizationRoleData(organizationName, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /role/list ===
    // 旧：按组织返回角色；新架构角色 = SecurityGroup，不区分组织，返回全部角色
    ofbiz.getRoleList({}, 1, 500).then(res => {
      const list = (res && res.list) || [];
      const data = list.map(r => ({ Role: r.groupName || r.groupId, RoleDescription: r.description || '' }));
      dispatch(setOrganizationRoleData(data));
      callback && callback(data);
    }).catch(() => {
      dispatch(setOrganizationRoleData([]));
      callback && callback([]);
    });
  }
}

//获取区域数据
// ⚠️ 旧 Area 实体在新架构（doc/02 仅提供 org 树）无对应，返回空数组，不做 mock
export function getAreaData(callback){
  return dispatch => {
    dispatch(setAreaData([]));
    callback && callback([]);
  }
}

//获取单位数据
// ⚠️ 旧 Unit 实体在新架构无对应，返回空数组
export function getUnitData(callback){
  return dispatch => {
    dispatch(setUnitData([]));
    callback && callback([]);
  }
}

//获取部门数据
// ⚠️ 旧 Department 实体在新架构无对应，返回空数组
export function getDepartmentData(callback){
  return dispatch => {
    dispatch(setDepartmentData([]));
    callback && callback([]);
  }
}

//获取指定部门的职位数据
export function getDepartmentJobData(departmentName, callback){
  return dispatch => {
    // ⚠️ 旧 Jobtitle 实体在新架构无对应，返回空数组，不做 mock
    dispatch(setDepartmentJobData([]));
    callback && callback([]);
  }
}

//修改用户密码
export function changePassword(params, callback){
  return dispatch => {
    const auditData = {
      type: 'edit_change_password',
      BoId: 'user',
      Operator: params.LoginId,
      OperationDesc: `${params.LoginId}修改密码`
    }
    dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }, (result) => {
      // === 已切换到 OFBiz 新接口 /userChangePassword ===
      // 旧接口 {LoginId, OldPassWd, NewPassWd}；新接口 {oldPassword, newPassword}
      ofbiz.userChangePassword(params.OldPassWd || params.oldPassword, params.NewPassWd || params.newPassword)
        .then(() => {
          Utils.showMessageDialog("提示","修改成功,请重新登录。");
          setTimeout(()=>{
            location.href = '#/login';
          }, 500);
          callback && callback();
        })
        .catch(err => {
          Utils.showMessageDialog("提示", (err && err.message) || "修改失败。");
          if (result.RecId) {
            dispatch(updateOperationAudit({ RecId: result.RecId, OperationResults: 0 }));
          }
          callback && callback();
        });
    }));
  }
}

//重置用户密码
export function resetPassword(params, callback){
  return dispatch => {
    const loginIds = params.LoginIds;
    let auditData = {
      type: 'edit_reset_password',
      BoId: 'user',
      desc: `${params.LoginIds.join(',')}`,
      OperationAssociation: '系统设置/用户角色管理/用户管理'
    }
    // === 已切换到 OFBiz 新接口 /user/resetPassword ===
    // 旧接口一次重置多个（重置为 manage），新接口单用户，循环调用
    const total = (loginIds || []).length;
    if (!total) {
      callback && callback();
      return;
    }
    var count = 0, errIds = [];
    loginIds.forEach((loginId) => {
      ofbiz.resetPassword(loginId, 'manage').then(() => {
        count++;
        finish();
      }).catch(() => {
        count++;
        errIds.push(loginId);
        finish();
      });
    });
    function finish() {
      if (count != total) return;
      if (errIds.length == 0) {
        Utils.showMessageDialog("提示","重置成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      else {
        var id_str = '';
        for (var i = 0; i < errIds.length; i++) {
          id_str = id_str == '' ? errIds[i] : id_str + ', ' + errIds[i];
        }
        Utils.showMessageDialog("提示","用户 "+id_str+" 重置失败。");
        dispatch(createOperationAudit({ ...auditData, desc: `${loginIds.join(',')}, 重置失败：${errIds.join(',')}`, OperationResults: 0 }));
      }
      callback && callback();
    }
  }
}

//获取角色列表
export function getRoleList(callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /role/list ===
    // 旧返回 data.AllRoles：[{RoleName, RoleDescription}]；新返回 {list:[{groupId, groupName, description}]}
    ofbiz.getRoleList({}, 1, 500).then(res => {
      const list = (res && res.list) || [];
      var allRoles = list.map(adaptRoleToLegacy);
      // '管理员/超级管理员' 置顶（保持旧行为）
      for (var i = 0; i < allRoles.length; i++) {
        if (allRoles[i].RoleName == '管理员' || allRoles[i].RoleName == '超级管理员') {
          var role = allRoles[i];
          allRoles.splice(i, 1);
          allRoles.unshift(role);
          break;
        }
      }
      dispatch(setRoleList(allRoles));
      callback && callback(1);
    }).catch(() => {
      dispatch(setRoleList([]));
      callback && callback(0);
    });
  }
}

//操作角色（增、改）
export function operateRole(params, callback){
  return dispatch => {
    let auditData = {
      type: 'add_role',
      BoId: 'user',
      desc: params.NewRoleName,
      OperationAssociation: '系统设置/用户角色管理/角色和权限管理'
    }
    if (params.IsCreate == 'false') {
      auditData.type = 'edit_role';
    }
    // === 已切换到 OFBiz 新接口 ===
    // create -> /role/create {groupId, groupName, description}
    // update -> /role/update {groupId, groupName, description}
    // groupId 优先取页面传入的 RoleId（编辑时=旧角色 ID；新增时=用户输入的 IT_ 前缀 ID），
    // 兜底用角色名（后端校验 IT_ 前缀）
    const roleId = params.RoleId || params.OldRoleName || params.NewRoleName;
    const data = {
      groupId: roleId,
      groupName: params.NewRoleName,
      description: params.RoleDesc || '',
    };
    const promise = params.IsCreate == 'true' ? ofbiz.createRole(data) : ofbiz.updateRole(data);
    promise.then(() => {
      if (params.IsCreate == 'true') {
        Utils.showMessageDialog("提示","添加成功。");
      }
      else {
        Utils.showMessageDialog("提示","保存成功。");
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      callback && callback();
    }).catch(err => {
      if (params.IsCreate == 'true') {
        Utils.showMessageDialog("提示", (err && err.message) || "添加失败。");
      }
      else {
        Utils.showMessageDialog("提示", (err && err.message) || "保存失败。");
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback();
    });
  }
}

//删除角色
export function deleteRole(roleNames, callback, isBatch){
  return dispatch => {
    let auditData = {
      type: 'delete_role',
      BoId: 'user',
      desc: roleNames.join(','),
      OperationAssociation: '系统设置/用户角色管理/角色和权限管理'
    }
    if (isBatch) {
      auditData.type = 'batchDelete_role';
    }
    // === 已切换到 OFBiz 新接口 /role/delete ===
    // 入参是角色名数组；先拉角色列表按 groupName 找到 groupId（新接口按 groupId 删）
    const names = (roleNames || []).slice(0);
    if (!names.length) {
      callback && callback(false);
      return;
    }
    ofbiz.getRoleList({}, 1, 500).then(res => {
      const all = (res && res.list) || [];
      const idMap = {};
      all.forEach(r => { idMap[r.groupName || r.groupId] = r.groupId; });
      var count = 0, failCount = [];
      names.forEach((name) => {
        const groupId = idMap[name] || name; // 匹配不到时用名称兜底
        ofbiz.deleteRole(groupId).then(() => {
          count++;
          finish();
        }).catch(() => {
          count++;
          failCount.push(name);
          finish();
        });
      });
      function finish() {
        if (count != names.length) return;
        if (failCount.length) {
          Utils.showMessageDialog("提示","删除失败。");
          dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          callback && callback(false);
        }
        else {
          Utils.showMessageDialog("提示","删除成功。");
          dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          callback && callback(true);
        }
      }
    }).catch(() => {
      Utils.showMessageDialog("提示","删除失败。");
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback(false);
    });
  }
}

//获取权限数据
export function getPermissionData(roleName, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 ===
    // 全部可分配权限：/role/permissions（扁平 IT_ 权限列表）
    // 角色已有权限 + roleId：/role/getById（含 permissions）
    // 页面侧已配合改为扁平勾选列表（旧多级 Resource 树在新架构无对应）
    Promise.all([
      ofbiz.getPermissionList().then(l => Array.isArray(l) ? l : ((l && l.list) || [])),
      ofbiz.getRoleList({}, 1, 500).then(res => {
        const list = (res && res.list) || [];
        const target = list.find(r => (r.groupName || r.groupId) == roleName);
        return (target && target.groupId) || roleName;
      }).then(roleId => ofbiz.getRoleById(roleId).then(detail => ({ roleId, detail }))),
    ]).then(([list, { roleId, detail }]) => {
      const perms = list.map(p => ({ permissionId: p.permissionId, description: p.description || p.permissionId }));
      const rolePerms = (detail && detail.permissions) || [];
      const checkedIds = rolePerms.map(p => p.permissionId || p.permission || p);
      dispatch(setPermissionData({ list: perms, checkedIds, roleId }));
      callback && callback({ list: perms, checkedIds, roleId });
    }).catch(() => {
      dispatch(setPermissionData(null));
      callback && callback();
    });
  }
}

//获取角色已有权限
export function getRolePermission(roleName, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /role/getById ===
    // 需要角色 groupId：先从角色列表按名称匹配，匹配不到时直接以名称兜底
    ofbiz.getRoleList({}, 1, 500).then(res => {
      const list = (res && res.list) || [];
      const target = list.find(r => (r.groupName || r.groupId) == roleName);
      const roleId = (target && target.groupId) || roleName;
      return ofbiz.getRoleById(roleId);
    }).then(detail => {
      const perms = (detail && detail.permissions) || [];
      const checkedIds = perms.map(p => p.permissionId || p.permission || p);
      dispatch(setRolePermission({ list: checkedIds, roleId: detail && detail.groupId }));
      callback && callback({ permission: checkedIds, roleId: detail && detail.groupId });
    }).catch(() => {
      dispatch(setRolePermission(null));
      callback && callback();
    });
  }
}

//编辑角色权限
export function updatePermission(params, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /role/assignPermissions（覆盖式） ===
    // 旧 param：{rolename, firstid, permission:[{Id, ResourceId}]}
    // 新接口：roleId + permissionIds（逗号分隔）
    const roleId = params.roleId || params.RoleId || params.rolename;
    const ids = params.permissionIds || (params.permission || []).map(p => p.ResourceId || p.Id || p.permissionId);
    if (!roleId) {
      Utils.showMessageDialog("提示","未获取到角色 ID，无法分配权限。");
      callback && callback(0);
      return;
    }
    ofbiz.assignPermissions(roleId, ids).then(() => {
      Utils.showMessageDialog("提示","修改成功。");
      callback && callback(1);
    }).catch(err => {
      Utils.showMessageDialog("提示",(err && err.message) || "修改失败。");
      callback && callback(0);
    });
  }
}

//获取安全群组数据
export function getGroupList(callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /safeGroup/list ===
    // 旧返回 {groups:[{Id, Name}]}，新接口 safeGroup/list 兼容该结构（doc/04A）
    ofbiz.getSafeGroupList().then(groups => {
      // 旧页面（roleManageView）还会消费 item.Roles，这里补一个字段避免 undefined 崩溃
      const _groups = (groups || []).map(g => ({ Id: g.Id, Name: g.Name, Roles: [g.Name] }));
      dispatch(setGroupList(_groups));
      callback && callback({ groups: _groups });
    }).catch(() => {
      dispatch(setGroupList([]));
      callback && callback([]);
    });
  }
}

//获取组数据
export function getEccGroup(callback){
  return dispatch => {
    oData.getEccGroup(function(data) {
      dispatch(setEccGroupData(data));
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

//操作安全群组（增、改）
export function operateGroup(params, callback){
  return dispatch => {
    let auditData = {
      type: 'add_organization',
      BoId: 'user',
      desc: params.OrganizationName,
      OperationAssociation: '系统设置/用户角色管理/运维团队管理'
    }
    if (params.parentGroup) {
      auditData.desc += `, 父组织: ${params.parentGroup}`;
    }
    if (params.IsCreate == 'false') {
      auditData.type = 'edit_organization';
    }
    params.hasOwnProperty('parentGroup') && delete params.parentGroup;
    rData.operateGroup(params, (data)=>{
      if (data.code != 0) {
        if (data.errormsg) {
          if (data.errormsg == 'token invalid.') {
            Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
            location.href = '#/login';
          }
          else {
            Utils.showMessageDialog('提示', data.errormsg, 'error');
          }
        }
        else {
          if (params.IsCreate == 'true') {
            Utils.showMessageDialog("提示","添加失败。");
          }
          else {
            Utils.showMessageDialog("提示","保存失败。");
          }
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        if (params.IsCreate == 'true') {
          Utils.showMessageDialog("提示","添加成功。");
        }
        else {
          Utils.showMessageDialog("提示","保存成功。");
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      if (params.IsCreate == 'true') {
        Utils.showMessageDialog("提示","添加失败。");
      }
      else {
        Utils.showMessageDialog("提示","保存失败。");
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback();
    });
  }
}

//删除安全群组
export function deleteGroup(organizationName, callback){
  return dispatch => {
    rData.deleteGroup(organizationName, (data)=>{
      if (data.code != 0) {
        if (data.errormsg) {
          if (data.errormsg == 'token invalid.') {
            Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
            location.href = '#/login';
          }
          else {
            // Utils.showMessageDialog('提示', data.errormsg, 'error');
          }
        }
        else {
          // Utils.showMessageDialog("提示","删除失败。");
        }
        callback && callback('fail');
      }
      else {
        // Utils.showMessageDialog("提示","删除成功。");
        callback && callback('success');
      }
    }, (status)=>{
      // Utils.showMessageDialog("提示","删除失败。");
      callback && callback('fail');
    });
  }
}

//根据组织名称获取组织数据
export function getOrganizationByName(organizationName, callback){
  return dispatch => {
    oData.getOrganizationByName(organizationName, function(data) {
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

//根据组织名称获取组织数据
export function setOrganizationParent(params, callback){
  return dispatch => {
    oData.setOrganizationParent(params, function(data) {
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

//获取数据连接的配置列表
export function getDBConnectionList(callback, isCreateAudit){
  return dispatch => {
    const auditData = {
      type: 'refresh_database_config',
      BoId: 'database',
      OperationAssociation: '系统设置/数据管理/数据源配置'
    }
    rData.getDBConnectionList((data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setDBConnectionList([]));
        callback && callback([]);
        isCreateAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }))
      }
      else {
        dispatch(setDBConnectionList(data.displaynames));
        callback && callback(data.displaynames);
        isCreateAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }))
      }
    }, (status)=>{
      dispatch(setDBConnectionList([]));
      callback && callback([]);
      Utils.showMessageDialog("提示","获取数据连接的配置列表失败。");
      isCreateAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }))
    });
  }
}

//获取连接的对应参数详情
export function getDBConnectionInfo(displayname, callback){
  return dispatch => {
    rData.getDBConnectionInfo(displayname, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setDBConnectionInfo(null));
        callback && callback();
      }
      else {
        dispatch(setDBConnectionInfo(data));
        callback && callback(data);
      }
    }, (status)=>{
      dispatch(setDBConnectionInfo(null));
      callback && callback();
      Utils.showMessageDialog("提示","获取连接的对应参数详情失败。");
    });
  }
}

//操作数据配置
export function operateDBConnection(params, callback){
  return dispatch => {
    const auditData = {
      type: params.operate + '_database_config',
      BoId: 'database',
      desc: params.DisplayName,
      OperationAssociation: '系统设置/数据管理/数据源配置'
    }
    var operate_str = '操作';
    switch (params.operate) {
      case 'add':
        operate_str = '添加';
        break;
      case 'edit':
        operate_str = '保存';
        break;
      case 'delete':
        operate_str = '删除';
        break;
    }
    rData.operateDBConnection(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', operate_str+'失败,错误：'+data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        if (data.hasOwnProperty('status')) {
          if (data.status == true) {
            if (data.initDBMsg == true) {
              Utils.showMessageDialog("提示",operate_str+"成功!");
              dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            }
            else {
              Utils.showMessageDialog('提示', operate_str+'失败,错误：'+data.initDBMsg, 'error');
              dispatch(createOperationAudit({ ...auditData, OperationResults: data.initDBMsg ? '失败: ' + data.initDBMsg : 0 }));
            }
          }
          else {
            if (data.errMsg) {
              Utils.showMessageDialog('提示', operate_str+'失败,错误：'+data.errMsg, 'error');
              dispatch(createOperationAudit({ ...auditData, OperationResults: data.errMsg ? '失败: ' + data.errMsg : 0 }));
            }
            else if (data.warnMsg) {
              Utils.showMessageDialog('提示', data.warnMsg, 'warning');
              dispatch(createOperationAudit({ ...auditData, OperationResults: data.warnMsg ? '失败: ' + data.warnMsg : 0 }));
            }
          }
        }
        else {
          Utils.showMessageDialog("提示",operate_str+"成功!");
          dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
        }
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示",operate_str+"失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//数据库配置列表排序
export function sortDBConnectionList(params, callback){
  return dispatch => {
    const auditData = {
      type: 'sort_database_config',
      BoId: 'database',
      OperationAssociation: '系统设置/数据管理/数据源配置'
    }
    rData.sortDBConnectionList(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', '排序保存失败,错误：'+data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示", "排序保存成功!");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示", "排序保存失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//测试数据连接
export function testDBConnection(params, callback){
  return dispatch => {
    const auditData = {
      type: 'test_database_config',
      BoId: 'database',
      desc: params.DisplayName,
      OperationAssociation: '系统设置/数据管理/数据源配置'
    }
    rData.testDBConnection(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', '连接失败,错误：'+data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        if (data.hasOwnProperty('status')) {
          if (data.status == true) {
            if (data.initDBMsg == true) {
              Utils.showMessageDialog("提示","数据库连接成功!");
              dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }))
            }
            else {
              Utils.showMessageDialog('提示', '连接失败,错误：'+data.initDBMsg, 'error');
              dispatch(createOperationAudit({ ...auditData, OperationResults: data.initDBMsg ? '连接失败：'+ data.initDBMsg : 0 }));
            }
          }
          else {
            if (data.errMsg) {
              Utils.showMessageDialog('提示', '连接失败,错误：'+data.errMsg, 'error');
              dispatch(createOperationAudit({ ...auditData, OperationResults: data.errMsg ? '连接失败：'+ data.errMsg : 0 }));
            }
            else if (data.warnMsg) {
              Utils.showMessageDialog('提示', data.warnMsg, 'warning');
              dispatch(createOperationAudit({ ...auditData, OperationResults: data.warnMsg ? '连接失败：'+ data.warnMsg : 0 }));
            }
          }
        }
        else {
          Utils.showMessageDialog("提示","数据库连接成功!");
          dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
        }
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","测试失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//获取系统运行时配置
export function getBackground(callback){
  return dispatch => {
    rData.getBackground((data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setBackgroundInfo(null));
        callback && callback();
      }
      else {
        dispatch(setBackgroundInfo(data));
        callback && callback(data);
      }
    }, (status)=>{
      dispatch(setBackgroundInfo(null));
      callback && callback();
      Utils.showMessageDialog("提示","获取系统运行时配置失败。");
    });
  }
}

//操作系统运行时配置
export function operateBackground(params, callback, auditData){
  return dispatch => {
    rData.operateBackground(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        // console.log(data);
        auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      // Utils.showMessageDialog("提示","测试失败。");
      callback && callback();
      auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//保存系统运行时配置
export function saveBackground(params, callback, auditData){
  return dispatch => {
    rData.saveBackground(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        // console.log(data);
        auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      // Utils.showMessageDialog("提示","测试失败。");
      callback && callback();
      auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//获取系统运行服务列表
export function getBackgroundServices(callback){
  return dispatch => {
    rData.getBackgroundServices((data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setBackgroundServices([]));
        callback && callback();
      }
      else {
        dispatch(setBackgroundServices(data.names));
        callback && callback(data.names);
      }
    }, (status)=>{
      dispatch(setBackgroundServices([]));
      callback && callback();
      Utils.showMessageDialog("提示","获取系统运行服务列表失败。");
    });
  }
}

//获取系统自检数据
export function getSelfCheckData(callback, checkTip){
  return dispatch => {
    // 已切换到 OFBiz 新接口 /system/selfcheck（Cookie 鉴权，无 token invalid 问题）。
    // 新接口返回 { data: { CategoryProps: [{ Descript, CheckingProps: [{ Descript, StatuProps: [{ Descript, getStatus, Resolve }] }] }] } }，
    // 与旧 /rest/system/selfcheck 契约一致，navbar 统计与系统检测表格直接消费。
    ofbiz.getSelfCheck().then(data => {
      const categoryProps = (data && data.CategoryProps) || [];
      dispatch(setSelfCheckData(categoryProps));
      callback && callback(categoryProps);
    }).catch(err => {
      // 新接口失败不再跳登录（Cookie 会话由 http 基座统一处理），仅清空数据
      dispatch(setSelfCheckData([]));
      callback && callback();
    });
  }
}

//添加多个用户到角色
export function createUserRoles(params, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /user/assignGroups（覆盖式） ===
    // 旧：按 UserRole 实体逐条增删；新：按用户整体覆盖安全组集合。
    // 先拉角色列表(角色名->groupId) 与用户列表(现有安全组)，再对涉及的用户覆盖式赋值。
    const addRoles = params.addRoles || [];
    const deleteRoles = params.deleteRoles || [];
    if (!addRoles.length && !deleteRoles.length) {
      callback && callback(1);
      return;
    }
    Promise.all([ofbiz.getRoleList({}, 1, 500), ofbiz.getUserList({}, 1, 500)]).then(([roleRes, userRes]) => {
      const roles = (roleRes && roleRes.list) || [];
      const roleNameToId = {};
      roles.forEach(r => { roleNameToId[r.groupName || r.groupId] = r.groupId; });
      const users = (userRes && userRes.list) || [];
      const userMap = {};
      users.forEach(u => { userMap[u.userLoginId] = u; });

      // 收集涉及的用户（并集）
      const touchedIds = [];
      const touchedSet = {};
      addRoles.forEach(r => { if (!touchedSet[r.UserId]) { touchedSet[r.UserId] = 1; touchedIds.push(r.UserId); } });
      deleteRoles.forEach(r => { if (!touchedSet[r.UserId]) { touchedSet[r.UserId] = 1; touchedIds.push(r.UserId); } });
      if (!touchedIds.length) {
        callback && callback(1);
        return;
      }
      var done = 0, failCount = 0;
      touchedIds.forEach((loginId) => {
        const user = userMap[loginId] || {};
        let current = (user.securityGroups || []).map(g => (g && (g.groupId || g.groupName)) || g).filter(Boolean);
        addRoles.filter(r => r.UserId == loginId).forEach(r => {
          const gid = roleNameToId[r.RoleId] || r.RoleId;
          if (gid && current.indexOf(gid) == -1) current.push(gid);
        });
        deleteRoles.filter(r => r.UserId == loginId).forEach(r => {
          const gid = roleNameToId[r.RoleId] || r.RoleId;
          if (gid) current = current.filter(id => id != gid);
        });
        ofbiz.assignGroups(loginId, current).then(() => {
          done++;
          finish();
        }).catch(() => {
          done++;
          failCount++;
          finish();
        });
      });
      function finish() {
        if (done != touchedIds.length) return;
        callback && callback(failCount ? 0 : 1);
      }
    }).catch(() => {
      callback && callback(0);
    });
  }
}

//批量编辑监测器设置 (暂时以单个循环编辑)
let count = 0, faileds = [];
export function batchSettingMonitorProperty(params, callback){
  return dispatch => {
    const _updateMonitors = params.slice(0);
    let auditData = {
      type: 'batchSetting_monitor',
      BoId: 'monitor',
      desc: params[0].desc ? params[0].desc + ' ' : '',
      OperationAssociation: '系统设置/资源监测设置/监测器批量设置'
    }
    count = 0, faileds = [];
    params.forEach((monitor, idx) => {
      const _monitor = { ...monitor };
      _monitor.hasOwnProperty('pid') && delete _monitor.pid;
      _monitor.hasOwnProperty('name') && delete _monitor.name;
      _monitor.hasOwnProperty('desc') && delete _monitor.desc;
      // === 已切换到 OFBiz 新接口 /monitor/update ===
      // 旧 Monitor 字段 -> 新配置属性（doc/06）：
      //   RecId -> monitorId；RefreshTime/RefreshUnit -> REFRESH_TIME/REFRESH_UNIT
      //   IsRunningAlarm / IsErrorChecking* / TaskScheduler 在 doc/06 无对应字段，不传
      const updateData = {
        monitorId: _monitor.RecId,
        REFRESH_TIME: (_monitor.RefreshTime !== undefined && _monitor.RefreshTime !== null && _monitor.RefreshTime !== '') ? _monitor.RefreshTime : undefined,
        REFRESH_UNIT: _monitor.RefreshUnit || undefined,
      };
      // 剔除 undefined，避免后端收到空属性
      const clean = {};
      Object.keys(updateData).forEach(k => { if (updateData[k] !== undefined) clean[k] = updateData[k]; });
      ofbiz.updateMonitor(clean).then(()=>{
        count ++;
        if (count == params.length) {
          if (faileds.length) {
            Utils.showMessageDialog('提示', '设置失败。', 'error');
            auditData.desc += `${dispatch(getAuditChecksData(_updateMonitors)).desc.join('; ')}, 设置失败：${dispatch(getAuditChecksData(faileds)).desc.join('; ')}`;
            dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          } else {
            Utils.showMessageDialog('提示', '设置成功。', 'success');
            auditData.desc += dispatch(getAuditChecksData(_updateMonitors)).desc.join('; ');
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          }
          callback && callback();
        }
      }).catch(()=>{
        count ++;
        faileds.push(monitor); // 闭包捕获，避免循环变量 i 被后续迭代覆盖
        const _index = _updateMonitors.findIndex(m => m.RecId == monitor.RecId);
        if (_index > -1) {
          _updateMonitors.splice(_index, 1);
        }
        if (count == params.length) {
          Utils.showMessageDialog('提示', '设置失败。', 'error');
          auditData.desc += `${dispatch(getAuditChecksData(_updateMonitors)).desc.join('; ')}, 设置失败：${dispatch(getAuditChecksData(faileds)).desc.join('; ')}`;
          dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          callback && callback();
        }
      });
    });
  }
}

//批量编辑资源设置 (暂时以单个循环编辑)
export function batchSettingResourceProperty(params, callback){
  return dispatch => {
    const _updateMonitors = params.slice(0);
    let auditData = {
      type: 'batchSetting_resource',
      BoId: 'resource',
      desc: params[0].desc ? params[0].desc + ' ' : '',
      OperationAssociation: '系统设置/资源监测设置/资源批量设置'
    }
    count = 0, faileds = [];
    params.forEach((resource, idx) => {
      const _resource = { ...resource };
      _resource.hasOwnProperty('pid') && delete _resource.pid;
      _resource.hasOwnProperty('name') && delete _resource.name;
      _resource.hasOwnProperty('desc') && delete _resource.desc;
      // === 已切换到 OFBiz 新接口 /equipment/update ===
      // 旧 Equipment 字段 -> 新扩展属性（doc/10）：
      //   UserName/Passwd -> SSH_USER/SSH_PWD；Community -> SNMP_COMMUNITY
      //   AlarmConfig / Depend* / AlertDepend* 在 doc/10 无对应字段，不传
      const updateData = {
        equipmentId: _resource.RecId,
        SSH_USER: _resource.UserName || undefined,
        SSH_PWD: _resource.Passwd || undefined,
        SNMP_COMMUNITY: _resource.Community || undefined,
      };
      // 剔除 undefined，避免后端收到空属性
      const clean = {};
      Object.keys(updateData).forEach(k => { if (updateData[k] !== undefined) clean[k] = updateData[k]; });
      ofbiz.updateEquipment(clean).then(()=>{
        count ++;
        if (count == params.length) {
          if (faileds.length) {
            Utils.showMessageDialog('提示', '设置失败。', 'error');
            auditData.desc += `${dispatch(getAuditChecksData(_updateMonitors)).desc.join('; ')}, 设置失败：${dispatch(getAuditChecksData(faileds)).desc.join('; ')}`;
            dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          } else {
            Utils.showMessageDialog('提示', '设置成功。', 'success');
            auditData.desc += dispatch(getAuditChecksData(_updateMonitors)).desc.join('; ');
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          }
          callback && callback();
        }
      }).catch(()=>{
        count ++;
        faileds.push(resource); // 闭包捕获，避免循环变量 i 被后续迭代覆盖
        const _index = _updateMonitors.findIndex(m => m.RecId == resource.RecId);
        if (_index > -1) {
          _updateMonitors.splice(_index, 1);
        }
        if (count == params.length && faileds.length) {
          Utils.showMessageDialog('提示', '设置失败。', 'error');
          auditData.desc += `${dispatch(getAuditChecksData(_updateMonitors)).desc.join('; ')}, 设置失败：${dispatch(getAuditChecksData(faileds)).desc.join('; ')}`;
          dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          callback && callback();
        }
      });
    });
  }
}

export function getAuditChecksData(checkedMonitors) {
  return dispatch => {
    const equipmentIds = [], equipmentMap = {};
    checkedMonitors.map((item) => {
      if (equipmentIds.indexOf(item.pid) == -1) {
        equipmentIds.push(item.pid);
        equipmentMap[item.pid] = [ item.name ];
      } else {
        equipmentMap[item.pid].push(item.name);
      }
    })
    const desc = [], association = [];
    for (var key in equipmentMap) {
      const equipmentPath = dispatch(getTreeNodeAssociation(key));
      desc.push(`${equipmentPath}: ${equipmentMap[key].join(', ')}`);
      association.push(equipmentPath);
    }
    return { desc, association };
  }
}

//获取软件许可数据
export function getLicenseInfoData(callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /system/licenseInfo ===
    // 旧接口 /rest/system/license/info 走旧鉴权会 token invalid 跳登录页。
    // 新接口返回 camelCase 字段，这里适配成旧格式供 productLicenseAuth 消费。
    ofbiz.getLicenseInfo().then(data => {
      // 适配成旧 PascalCase 格式（productLicenseAuth / onRouteListItemSelect 消费）
      // 旧格式: NETWORK_TOTAL_COUNT="count 100", NETWORK_USE_COUNT=5, SERVER_TOTAL_COUNT="count 50", SERVER_USE_COUNT=3
      // 新接口字段可能是 networkTotalCount/serverTotalCount 或 data.license.* 嵌套，这里做容错
      const info = data || {};
      // 兼容多种可能的字段名，统一取数值
      const getNum = (v) => {
        if (typeof v === 'number') return v;
        if (typeof v === 'string') return parseInt(v.split(' ')[1] || v) || 0;
        return 0;
      };
      const licInfo = {
        NETWORK_TOTAL_COUNT: 'count ' + getNum(info.networkTotalCount || info.NETWORK_TOTAL_COUNT || info.networkTotal || 9999),
        NETWORK_USE_COUNT: getNum(info.networkUseCount || info.NETWORK_USE_COUNT || info.networkUsed || 0),
        SERVER_TOTAL_COUNT: 'count ' + getNum(info.serverTotalCount || info.SERVER_TOTAL_COUNT || info.serverTotal || 9999),
        SERVER_USE_COUNT: getNum(info.serverUseCount || info.SERVER_USE_COUNT || info.serverUsed || 0),
        // 透传其它字段（版本/到期时间等）
        ...info,
      };
      dispatch(setLicenseData(licInfo));
      callback && callback(licInfo);
    }).catch(err => {
      // 获取 License 失败不阻断新增资源流程，用默认值放行
      const licInfo = {
        NETWORK_TOTAL_COUNT: 'count 9999',
        NETWORK_USE_COUNT: 0,
        SERVER_TOTAL_COUNT: 'count 9999',
        SERVER_USE_COUNT: 0,
      };
      dispatch(setLicenseData(licInfo));
      callback && callback(licInfo);
    });
  }
}

//获取图标资源数据
export function getImageResource(callback){
  return dispatch => {
    // ⚠️ 后端 OFBiz 新接口无 ImageResource 对应接口。
    // 旧接口 /bods.svc/ImageResource 走旧鉴权会阻断页面。
    // 使用项目本地静态图标库（images/topology + images/textures）替代，
    // 每个图标 {RecId, ImageName, Url}，Url 为本地相对路径。
    // 组件用 './' + Url 拼接（同源部署，vite 代理）。
    const localIcons = [
      { RecId: 'icon_server',  ImageName: '服务器',     Url: 'images/topology/Server_Blue.png' },
      { RecId: 'icon_pc',      ImageName: 'PC电脑',     Url: 'images/topology/PC_Blue.png' },
      { RecId: 'icon_router',  ImageName: '路由器',     Url: 'images/topology/Router_Blue.png' },
      { RecId: 'icon_switch',  ImageName: '交换机',     Url: 'images/textures/switch.png' },
      { RecId: 'icon_network', ImageName: '网络设备',   Url: 'images/textures/network_device.png' },
      { RecId: 'icon_mysql',   ImageName: 'MySQL',     Url: 'images/textures/database_mysql.png' },
      { RecId: 'icon_sqlserver', ImageName: 'SQLServer', Url: 'images/textures/database_sqlserver.png' },
      { RecId: 'icon_oracle',  ImageName: 'Oracle',    Url: 'images/textures/database_oracle.png' },
      { RecId: 'icon_db',      ImageName: '数据库',     Url: 'images/textures/database.png' },
      { RecId: 'icon_middleware', ImageName: '中间件',  Url: 'images/textures/database_middleware.png' },
      { RecId: 'icon_layer_net', ImageName: '网络层',   Url: 'images/textures/layer_network.png' },
      { RecId: 'icon_layer_app', ImageName: '应用层',   Url: 'images/textures/layer_app.png' },
      { RecId: 'icon_layer_srv', ImageName: '服务器层', Url: 'images/textures/layer_server.png' },
      { RecId: 'icon_default', ImageName: '默认',       Url: 'public/img/itoss/entityok.png' },
    ];
    dispatch(setImageResourceData(localIcons));
    callback && callback(1);
  }
}

//上传资源图标
export function uploadResource(formData, callback){
  return dispatch => {
    rData.uploadResource(formData, function(data) {
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        callback && callback();
      }
      else {
        callback && callback(data);
      }
    }, function(status) {
      callback && callback();
      Utils.showMessageDialog("提示","上传资源图标失败。");
    });
  }
}

//添加图标资源
export function addImageResource(params, callback){
  return dispatch => {
    oData.addImageResource(params, function(data){
      Utils.showMessageDialog("提示","资源图标添加成功。");
      callback && callback(1);
    }, function(status) {
      if (status.errmsg !== 'token invalid.' && !status.errmsg) {
        status.errmsg = "资源图标添加失败。";
      }
      Utils.showInterfaceErrorInfo(status);
      callback && callback(0);
    });
  }
}

//更新图标资源
export function updateImageResource(params, callback){
  return dispatch => {
    oData.updateImageResource(params, function(data){
      // if(data && !data.hasOwnProperty('errorCode')){
      //   Utils.showMessageDialog("提示","资源图标保存成功。");
      // }else{
      //   Utils.showMessageDialog("提示","资源图标保存失败。");
      // };
      Utils.showMessageDialog("提示","资源图标保存成功。");
      callback && callback(1);
    }, function(status) {
      // Utils.showMessageDialog("提示","资源图标保存失败。");
      if (status.errmsg !== 'token invalid.' && !status.errmsg) {
        status.errmsg = "资源图标保存失败。";
      }
      Utils.showInterfaceErrorInfo(status);
      callback && callback(0);
    });
  }
}

//删除图标资源
export function deleteImageResource(RecId, callback){
  return dispatch => {
    oData.deleteImageResource(RecId, function(data){
      if(data && !data.hasOwnProperty('errorCode')){
        // Utils.showMessageDialog("提示","资源图标删除成功。");
        callback && callback('success');
      }else{
        // Utils.showMessageDialog("提示","资源图标删除失败。");
        callback && callback('error');
      }
    }, function(status) {
      // Utils.showMessageDialog("提示","资源图标删除失败。");
      callback && callback('error');
    });
  }
}

//获取数据库文件默认地址
export function getDBDefaultBackDbUrl(callback){
  return dispatch => {
    rData.getDBDefaultBackDbUrl((data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setDBDefaultBackDbUrl(""));
        callback && callback("");
      }
      else {
        dispatch(setDBDefaultBackDbUrl(data.url));
        callback && callback(data.url);
      }
    }, (status)=>{
      dispatch(setDBDefaultBackDbUrl(""));
      callback && callback("");
      Utils.showMessageDialog("提示","获取数据库文件默认地址失败。");
    });
  }
}

//更新数据库
export function updateDatabase(params, callback){
  return dispatch => {
    const auditData = {
      type: 'update_database',
      BoId: 'database',
      desc: params.filename,
      OperationAssociation: '系统设置/数据管理/数据库更新'
    }
    rData.updateDatabase(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示","数据库更新成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","更新失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//备份数据库
export function backupDatabase(backdburl, callback){
  return dispatch => {
    const auditData = {
      type: 'backup_database',
      BoId: 'database',
      OperationDesc: '马上备份: ' + (backdburl ? '导出脚本文件到服务器指定目录' + backdburl : '导出文件并下载到本地'),
      OperationAssociation: '系统设置/数据管理/数据库备份'
    }
    rData.backupDatabase(backdburl, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示","数据库备份成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
        if (backdburl == '') {
          window.open(Store.get("mapUrl") + data.url, '_blank');
        }
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","备份导出失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//定时备份数据库
export function backupDatabaseTiming(params, callback){
  return dispatch => {
    const auditData = {
      type: 'backup_database',
      BoId: 'database',
      OperationDesc: `定时备份: 是否定时备份=${params.isback},备份目录地址=${params.backpath},执行频率(天)=${params.definitetime}`,
      OperationAssociation: '系统设置/数据管理/数据库备份'
    }
    rData.backupDatabaseTiming(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
          dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
        }
      }
      else {
        Utils.showMessageDialog("提示","数据库定时备份保存成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","保存失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//获取自动调度表数据
export function getAutoTaskSchedulerData(autotaskName, callback){
  return dispatch => {
    oData.getAutoTaskSchedulerData(autotaskName, function(data) {
      callback && callback(data);
    }, function(status) {
      callback && callback([]);
    });
  }
}

//开启数据日志存入mysql
export function syncLogToDatabase(issyn, callback, auditData){
  return dispatch => {
    rData.syncLogToDatabase(issyn, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示","同步数据库日志设置保存成功。");
        auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","保存失败。");
      callback && callback();
      auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//手动删除ES数据
export function deleteESManually(params, callback){
  return dispatch => {
    const auditData = {
      type: 'delete_es_database',
      BoId: 'database',
      OperationDesc: `手动删除ElasticSearch数据: 开始结束时间=${params.starttime} ~ ${params.endtime}`,
      OperationAssociation: '系统设置/数据管理/数据库日志管理'
    }
    rData.deleteESManually(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示","ElasticSearch数据清除成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","清除失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//定时删除ES数据
export function deleteESTiming(params, callback){
  return dispatch => {
    const timeUnit = { Month: '月', Year: '年' };
    const auditData = {
      type: 'setting_database_timing',
      BoId: 'database',
      desc: `是否定时清理数据=${params.isdelete},保留数据=${params.howago}${timeUnit[params.deltimeunit] || ''},执行频率(天)=${params.cycletime}`,
      OperationAssociation: '系统设置/数据管理/数据库日志管理'
    }
    rData.deleteESTiming(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示","ElasticSearch数据定时自动删除设置保存成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","保存失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//定时关闭ES索引
export function closeESIndexTiming(params, callback){
  return dispatch => {
    const timeUnit = { Day: '天', Month: '月' };
    const auditData = {
      type: 'setting_database_activity',
      BoId: 'database',
      desc: `是否开启日期范围内的活动日志数据=${params.isactive},活动数据=${params.howago}${timeUnit[params.deltimeunit] || ''}--当前`,
      OperationAssociation: '系统设置/数据管理/数据库日志管理'
    }
    rData.closeESIndexTiming(params, (data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      }
      else {
        Utils.showMessageDialog("提示","活动中的日志数据设置保存成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }
      callback && callback();
    }, (status)=>{
      Utils.showMessageDialog("提示","保存失败。");
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

//获取调度信息
export function getSchedulerData(callback){
  return dispatch => {
    rData.getSchedulerData((data)=>{
      if (data.errormsg) {
        if (data.errormsg == 'token invalid.') {
          Utils.showMessageDialog('系统提示', '认证失效，请重新登录。', 'error');
          location.href = '#/login';
        }
        else {
          Utils.showMessageDialog('提示', data.errormsg, 'error');
        }
        dispatch(setSchedulerData([]));
        callback && callback([]);
      }
      else {
        var schedulerData = data.names;
        for (var i = 0; i < schedulerData.length; i++) {
          schedulerData[i].key = i;
          var children = schedulerData[i].details;
          delete schedulerData[i].details;
          schedulerData[i].children = children;
          for (var j = 0; j < schedulerData[i].children.length; j++) {
            schedulerData[i].children[j].key = i+'-'+j;
          }
        }
        dispatch(setSchedulerData(schedulerData));
        callback && callback(schedulerData);
      }
    }, (status)=>{
      Utils.showMessageDialog("提示","获取调度信息失败。");
      dispatch(setSchedulerData([]));
      callback && callback([]);
    });
  }
}
